<template>
<img svg-inline class="icon" :src="svgImgPath" :width="Width" :height="Height" />
</template>

<script>
export default {
    props: {
        svgImgPath: {
            type: String,
            required: true
        },
        Width: {
            type: Number,
            default: 64
        },
        Height: {
            type: Number,
            default: 64
        }
    }
}
</script>
